<template>
  <div class="wrap">
    <p class="pageTitle">功能集详情</p>
    <div class="form">
      <el-form :model="form" :inline="true" label-position="right" ref="form" label-width="150px">
        <el-form-item class="mr20" label="功能集名称：">{{form.name}}</el-form-item>
        <el-form-item
          class="ml20"
          label="是否纳入食安指数分析："
          label-width="400"
          prop="enableIndex"
        >{{form.enableIndex === 0? '否':'是'}}</el-form-item>
        <el-form-item label="功能集描述: " prop="remarks">{{form.remarks}}</el-form-item>
      </el-form>
    </div>
    <div class="box">
      <toggle-form title="功能模块">
        <div class="singleBox">
          <p class="moduleTitle">通用功能模块</p>
          <ul class="clear_a">
            <li class="clear_a" v-for="(item,index) in moduleData" :key="index">
              <p class="moduleName">{{item.moduleName}}</p>
              <el-switch
                disabled
                class="mt2 fr"
                v-model="item.defaultState"
                active-color="#13ce66"
                inactive-color="#dcdfe6"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
              <p class="switch mr10 fr">{{item.defaultState === 0?'禁用':'启用'}}</p>
            </li>
          </ul>
          <p class="moduleTitle">PC网页端功能模块</p>
          <ul class="clear_a">
            <li class="clear_a" v-for="(item,index) in pcData" :key="index">
              <p class="moduleName">{{item.moduleName}}</p>
              <el-switch
                disabled
                class="mt2 fr"
                v-model="item.defaultState"
                active-color="#13ce66"
                inactive-color="#dcdfe6"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
              <p class="switch mr10 fr">{{item.defaultState === 0?'禁用':'启用'}}</p>
            </li>
          </ul>
          <p class="moduleTitle">一店一码功能模块</p>
          <ul class="clear_a">
            <li class="clear_a" v-for="(item,index) in oneStoreModuleData" :key="index">
              <p class="moduleName">{{item.moduleName}}</p>
              <el-switch
                disabled
                class="mt2 fr"
                v-model="item.defaultState"
                active-color="#13ce66"
                inactive-color="#dcdfe6"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
              <p class="switch mr10 fr">{{item.defaultState === 0?'禁用':'启用'}}</p>
            </li>
          </ul>
        </div>
      </toggle-form>
      <toggle-form title="公示模块">
        <div class="singleBox">
          <ul class="clear_a">
            <li class="clear_a" v-for="(item,index) in publicity" :key="index">
              <p class="moduleName">{{item.moduleName}}</p>
              <el-switch
                disabled
                class="mt2 fr"
                v-model="item.defaultState"
                active-color="#13ce66"
                inactive-color="#dcdfe6"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
              <p class="switch mr10 fr">{{item.defaultState === 0?'禁用':'启用'}}</p>
            </li>
          </ul>
        </div>
      </toggle-form>
      <toggle-form title="预警模块">
        <div class="singleBox" v-for="(items, i) in Object.keys(warningData)" :key="i">
          <p class="moduleTitle">{{warningName[items]}}</p>
          <ul class="clear_a">
            <li class="clear_a" v-for="(item,index) in warningData[items]" :key="index">
              <p class="moduleName">{{item.moduleName}}</p>
              <el-switch
                class="mt2 fr"
                v-model="item.defaultState"
                disabled
                active-color="#13ce66"
                inactive-color="#dcdfe6"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
              <p class="switch mr10 fr">{{item.defaultState === 0?'禁用':'启用'}}</p>
            </li>
          </ul>
        </div>
      </toggle-form>
    </div>
    <div class="fr">
      <el-button type="primary" class="mt20" @click="goEdit()">编辑</el-button>
    </div>
  </div>
</template>
<script>
import ToggleForm from "components/ToggleForm"
import * as api from "api/module";
export default {
  components: {
    ToggleForm
  },
  data() {
    return {
      form: {},
      id: '',
      moduleData: [],
      oneStoreModuleData: [],
      pcData: [],
      publicity: [],
      warningData: {
        after_cooking_management_abnormal: [],
        ai_camera_abnormal: [],
        source_trace_abnormal: [],
        pesticide_detection_abnormal: [],
        general_abnormal: [],
        supervision_inspection_abnormal: [],
      },
      warningName: {
        after_cooking_management_abnormal: '后厨管理异常',
        ai_camera_abnormal: 'AI摄像头',
        source_trace_abnormal: '溯源异常',
        pesticide_detection_abnormal: '检测异常',
        general_abnormal: '一般异常',
        supervision_inspection_abnormal: '监督检查异常',
      },
    }
  },
  methods: {
    async getMoudleDetail() {
      let result = await api.getModuleDetail({ id: this.id });
      this.form = result.data
    },
    async getMoudle() {
      const loading = this.$loading();
      let result = await api.getModule();
      await this.getMoudleDetail()
      let publicId = this.form.publicCollection.split(',')
      let funcId = this.form.functionCollection.split(',')
      let warn = this.form.warningCollection.split(',')
      let idArr = [...publicId, ...funcId,...warn]
      result.data.map(item => {
        item.defaultState = 0
        idArr.map(items => {
          item.id === items ? item.defaultState = 1 : ''
        })
      })
      loading.close();
      result.data.map(item => {
        switch (item.subGroupString) {
          case 'one_store_common_function':
            this.oneStoreModuleData.push(item);
            break;
          case 'common_function':
            this.moduleData.push(item);
            break;
          case 'default':
            this.publicity.push(item);
            break;
          case 'pc_web_function':
            this.pcData.push(item);
            break;
          case 'after_cooking_management_abnormal':
            this.warningData.after_cooking_management_abnormal.push(item);
            break;
          case 'ai_camera_abnormal':
            this.warningData.ai_camera_abnormal.push(item);
            break;
          case 'source_trace_abnormal':
            this.warningData.source_trace_abnormal.push(item);
            break;
          case 'pesticide_detection_abnormal':
            this.warningData.pesticide_detection_abnormal.push(item)
            break;
          case 'general_abnormal':
            this.warningData.general_abnormal.push(item);
            break;
          case 'supervision_inspection_abnormal':
            this.warningData.supervision_inspection_abnormal.push(item);
            break;

        }
      })
      this.publicity = result.data.filter((item) => { return item.groupString === 'public_module' })
      // this.moduleData = result.data.filter((item) => { return item.subGroupString === 'common_function' })
      this.pcData = result.data.filter((item) => { return item.subGroupString === 'pc_web_function' })
    },
    goEdit(){
      this.$router.push({
        name:'ModuleEdit',
        query:{
          id:this.form.id
        }
      })
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.getMoudle()
  }

}
</script>
<style lang="scss" scoped>
.wrap {
  text-align: left;
  .pageTitle {
    font-size: 20px;
    font-family: AlibabaPuHuiTiR;
    color: #333333;
    line-height: 20px;
    margin-bottom: 40px;
  }
  .form {
    margin: 20px auto;
    width: 1000px;
  }
  .box {
    margin: 20px auto 100px auto;
    width: 1000px;
    .singleBox {
      padding: 0 30px;
      box-sizing: border-box;
      > ul > li {
        width: 300px;
        height: 60px;
        background: rgba(244, 244, 244, 1);
        border-radius: 4px;
        padding: 18px 30px;
        box-sizing: border-box;
        margin-top: 20px;
        margin-right: 20px;
        .moduleName {
          font-size: 16px;
          font-family: AlibabaPuHuiTiR;
          color: rgba(51, 51, 51, 1);
          line-height: 24px;
        }
        .mt2 {
          margin-top: 2px;
        }
        .switch {
          font-size: 14px;
          font-family: AlibabaPuHuiTiR;
          color: rgba(102, 102, 102, 1);
          line-height: 24px;
        }
      }
      > ul > li:nth-child(3n) {
        margin-right: 0;
      }
    }
    .moduleTitle {
      font-size: 14px;
      font-family: AlibabaPuHuiTiR;
      color: rgba(102, 102, 102, 1);
      line-height: 20px;
      margin-top: 20px;
    }
  }
}
</style>
